import React, { createContext, useContext, useState } from "react";

const DateTimezoneContext = createContext({});

export const DateTimezoneContextProvider = ({ children  }) => {
  const [dashboardDate, setDashboardDate] = useState(new Date());
  const [dashboardTimezone, setDashboardTimezone] = useState();

  return (
    <DateTimezoneContext.Provider
      value={{
        dashboardDate,
        setDashboardDate,
        dashboardTimezone,
        setDashboardTimezone,
      }}
    >
      {children }
    </DateTimezoneContext.Provider>
  );
}

// Create a custom hook to easily access the context values
export const useDateTimezone = () => {
    return useContext(DateTimezoneContext);
  };
